import styled from 'styled-components';

export const AdjustPricingModalContainer = styled.div`
  margin-top: 24px;
`;

export const PlatformSection = styled.div`
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const PlatformName = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #2f3d48;
  margin-bottom: 16px;
`;

export const AmountField = styled.div`
  width: 100%;

  input {
    width: 100%;
  }
`;

export const TypeField = styled.div`
  width: 100%;

  .MuiFormControl-root {
    width: 100%;
  }
`;
